import CompassRouteGame from './games/CompassRouteGame';
import DualTrackGame from './games/DualTrackGame';
import FocusBlinkGame from './games/FocusBlinkGame';
import LineJudgeGame from './games/LineJudgeGame';
import OrbitTrackerGame from './games/OrbitTrackerGame';
import RuleMatrixGame from './games/RuleMatrixGame';
import SourceBindGame from './games/SourceBindGame';
import ToneOrderGame from './games/ToneOrderGame';
import TowerPlanGame from './games/TowerPlanGame';

export const DISTINCT_GAME_DEFINITIONS = [
    {
        id: 'orbit-tracker',
        title: 'Orbit Tracker',
        shortTitle: 'Orbit',
        focus: 'Dynamic attention',
        summary: 'Track several moving targets after their markers disappear.',
        action: 'Track targets',
        icon: 'eye',
        group: 'other',
        plain: true,
        hud: { score: true, streak: true },
        tutorial: ['Watch the marked dots.', 'Keep tracking as they move.', 'Tap the original targets.'],
        Component: OrbitTrackerGame,
    },
    {
        id: 'tone-order',
        title: 'Tone Order',
        shortTitle: 'Tones',
        focus: 'Auditory sequencing',
        summary: 'Hear a tone sequence and identify its exact pitch order.',
        action: 'Hear order',
        icon: 'repeat',
        group: 'other',
        plain: true,
        hud: { score: true, streak: true },
        tutorial: ['Tap play and listen.', 'Remember low, middle, and high.', 'Choose the same order.'],
        Component: ToneOrderGame,
    },
    {
        id: 'focus-blink',
        title: 'Focus Blink',
        shortTitle: 'Blink',
        focus: 'Temporal attention',
        summary: 'Detect two numbers hidden inside a rapid stream of letters.',
        action: 'Catch both',
        icon: 'numbers',
        group: 'other',
        plain: true,
        hud: { score: true, streak: true },
        tutorial: ['Watch the rapid stream.', 'Catch both numbers.', 'Enter them in order.'],
        Component: FocusBlinkGame,
    },
    {
        id: 'rule-matrix',
        title: 'Rule Matrix',
        shortTitle: 'Matrix',
        focus: 'Inductive reasoning',
        summary: 'Infer the row and column rule to complete an abstract matrix.',
        action: 'Complete matrix',
        icon: 'grid',
        group: 'other',
        plain: true,
        hud: { score: true, streak: true },
        tutorial: ['Inspect every row and column.', 'Rules change numbers, shapes, or positions.', 'Choose the missing tile.'],
        Component: RuleMatrixGame,
    },
    {
        id: 'tower-plan',
        title: 'Tower Plan',
        shortTitle: 'Tower',
        focus: 'Planning',
        summary: 'Plan a short sequence of moves to match a goal arrangement.',
        action: 'Plan moves',
        icon: 'layers',
        group: 'other',
        plain: true,
        hud: { mistakes: true, score: true, streak: true },
        tutorial: ['Match the top arrangement.', 'Move only the top ball on a peg.', 'Use as few moves as possible.'],
        Component: TowerPlanGame,
    },
    {
        id: 'source-bind',
        title: 'Source Bind',
        shortTitle: 'Source',
        focus: 'Object-location memory',
        summary: 'Bind each object to its location, then recover the requested source.',
        action: 'Recall location',
        icon: 'puzzle',
        group: 'other',
        plain: true,
        hud: { score: true, streak: true },
        tutorial: ['Study every object and location.', 'One object returns.', 'Tap where it was.'],
        Component: SourceBindGame,
    },
    {
        id: 'compass-route',
        title: 'Compass Route',
        shortTitle: 'Compass',
        focus: 'Route integration',
        summary: 'Integrate a sequence of turns and locate the final position.',
        action: 'Follow route',
        icon: 'diagram',
        group: 'other',
        plain: true,
        hud: { score: true, streak: true },
        tutorial: ['Remember the starting square.', 'Follow each arrow mentally.', 'Tap the final square.'],
        Component: CompassRouteGame,
    },
    {
        id: 'line-judge',
        title: 'Line Judge',
        shortTitle: 'Lines',
        focus: 'Visual discrimination',
        summary: 'Match a briefly shown orientation as differences become smaller.',
        action: 'Match angle',
        icon: 'eye',
        group: 'other',
        plain: true,
        hud: { score: true, streak: true },
        tutorial: ['Study the first line.', 'Compare all four options.', 'Choose the exact angle.'],
        Component: LineJudgeGame,
    },
    {
        id: 'dual-track',
        title: 'Dual Track',
        shortTitle: 'Dual Track',
        focus: 'Bimanual coordination',
        summary: 'Guide two independent cursors through moving lanes with one thumb on each control.',
        action: 'Guide both',
        icon: 'diagram',
        group: 'other',
        plain: true,
        hud: { mistakes: true, score: true },
        tutorial: ['Rotate your phone sideways.', 'Drag one control with each thumb.', 'Keep both markers inside their lanes.'],
        Component: DualTrackGame,
    },
];
